<div class="filter-toolbar">
	<div class="btn-group btn-group-sm" role="group">
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('all')"
			title="Alle Punkte anzeigen">
			Alle
		</button>
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'map' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('map')"
			title="Nur Punkte im Kartenausschnitt">
			Karte
			<span *ngIf="mapFilterStale && listFilterMode === 'map'" class="stale-indicator">&#x21bb;</span>
		</button>
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'selection' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('selection')"
			title="Nur ausgewählte Punkte">
			Auswahl
		</button>
	</div>
	<div ngbDropdown class="mt-1" *ngIf="aus.canI('use', 'filter')">
		<button type="button" class="btn btn-sm w-100" ngbDropdownToggle
			[ngClass]="currentFilterName ? 'btn-info' : 'btn-outline-secondary'">
			{{ currentFilterName || 'Filter' }}
		</button>
		<div ngbDropdownMenu class="w-100">
			<button ngbDropdownItem (click)="clearFilter()">
				<em>Kein Filter</em>
			</button>
			<button ngbDropdownItem *ngIf="showProjectPointsFilter && pps.totalCount() > 0" (click)="applyProjectPointsFilter()"
				[class.active]="currentFilterName === 'Projektpunkte'">
				Alle Projektpunkte ({{ pps.totalCount() }})
			</button>
			<div class="dropdown-divider" *ngIf="filterNames.length > 0"></div>
			<button ngbDropdownItem *ngFor="let name of filterNames" (click)="applyQuickFilter(name)"
				[class.active]="currentFilterName === name">
				{{ name }}
			</button>
			<div class="dropdown-divider"></div>
			<button ngbDropdownItem (click)="openFilterEditor()">
				Filter bearbeiten...
			</button>
		</div>
	</div>
	<div class="input-group input-group-sm mt-1">
		<input type="text" class="form-control" placeholder="Nr, Amt, Revier..."
			[(ngModel)]="searchText" (ngModelChange)="onSearchTextChange($event)"
			[class.search-active]="searchText"
			title="Sucht in: Nummer, Forstamt, Revier, Kartierer, Typ, Jahr, Vegetation, FBF, HBF, Humusform">
		<button *ngIf="searchText" class="btn btn-outline-secondary" type="button" (click)="clearSearch()" title="Suche löschen">x</button>
	</div>
	<!-- Auswahl-Aktionen -->
	<div class="btn-group btn-group-sm mt-1 w-100" role="group">
		<button type="button" class="btn btn-outline-success"
			[disabled]="!bps.length"
			(click)="addVisibleToSelection()"
			title="In Liste enthaltene übernehmen">
			<bi name="plus-lg"></bi>
		</button>
		<button type="button" class="btn btn-outline-danger"
			[disabled]="selectionService.count() === 0"
			(click)="removeVisibleFromSelection()"
			title="Sichtbare aus Auswahl entfernen">
			<bi name="dash-lg"></bi>
		</button>
		<button type="button" class="btn btn-outline-secondary"
			[disabled]="selectionService.count() === 0"
			(click)="invertVisibleSelection()"
			title="Auswahl der sichtbaren Punkte umkehren">
			<bi name="arrow-left-right"></bi>
		</button>
		<button type="button" class="btn btn-outline-secondary"
			[disabled]="selectionService.count() === 0"
			(click)="clearSelection()"
			title="Auswahl aufheben">
			<bi name="x-circle"></bi>
		</button>
		<!-- Einstellungen -->
		<button type="button" class="btn btn-outline-secondary"
			[class.active]="onlyWithProtocol || sortToTop !== 'none'"
			(click)="openSettings()"
			title="Listeneinstellungen">
			<bi name="gear"></bi>
		</button>
	</div>
</div>
<div class="leftmenu-container">
	<div class="leftmenu">
		<!-- Hinweis und Buttons wenn mehr Punkte vorhanden als angezeigt -->
		<div *ngIf="hasMoreItems" class="list-limit-info">
			<span>{{ visibleBps.length }} von {{ totalVisibleCount }} Punkten</span>
			<span class="load-more-buttons">
				<button class="btn btn-link btn-sm" (click)="loadMore()">+{{ totalVisibleCount - visibleBps.length > 500 ? 500 : totalVisibleCount - visibleBps.length }}</button>
				<button class="btn btn-link btn-sm" (click)="loadAll()">Alle</button>
			</span>
		</div>
		<a *ngFor="let item of visibleBps; trackBy: trackByBpId" [id]="'id-'+item.bp._id" class="dropdown-item list-entry" (click)="select($event, item.bp)"
			[ngClass]="{
				'active': activeId && activeId === item.bp._id,
				'list-item-filtered': pointsFilter && pointsFilter[item.originalIndex],
				'list-item-selected': selectionService.isSelected(item.bp._id)
			}">
			<!-- Punkte mit Protokoll -->
			<ng-container *ngIf="istPunktartMitProtokoll(item.bp.type)">
				<div class="list-entry-main">
					<img [src]="getSvgUrl(item.bp)" class="symbol-icon" alt="">
					<span class="bp-nummer" *ngIf="item.bp.header?.nummer">{{ item.bp.header.nummer }}</span>
					<button type="button" class="btn-protokoll" (click)="openProtokoll($event, item.bp)" title="Protokoll öffnen">
						<bi name="file-text"></bi>
						<span class="comment-indicator" [ngClass]="getCommentClass(item.bp)"></span>
					</button>
				</div>
				<div class="list-entry-sub">{{ (getKartierer(item.bp) || 'kein Kartierer') | maskForGuest }}</div>
			</ng-container>
			<!-- Punkte ohne Protokoll (Kurzprotokoll) -->
			<ng-container *ngIf="!istPunktartMitProtokoll(item.bp.type)">
				<div class="list-entry-main">
					<img [src]="getSvgUrl(item.bp)" class="symbol-icon" alt="">
					<button type="button" class="btn-protokoll" (click)="openProtokoll($event, item.bp)" title="Kurzprotokoll öffnen">
						<bi name="file-text"></bi>
						<span class="comment-indicator" [ngClass]="getCommentClass(item.bp)"></span>
					</button>
				</div>
				<div class="list-entry-sub">
					<span *ngIf="getKurzinfoRed(item.bp) || getKurzinfoGreen(item.bp)">
						<span class="kurzinfo-red" *ngIf="getKurzinfoRed(item.bp)">{{ getKurzinfoRed(item.bp) }}</span>
						<span class="kurzinfo-green" *ngIf="getKurzinfoGreen(item.bp)">{{ getKurzinfoGreen(item.bp) }}</span>
					</span>
					<span class="kartierer-info">{{ (getKartierer(item.bp) || 'kein Kartierer') | maskForGuest }}</span>
				</div>
			</ng-container>
		</a>
	</div>
</div>
<!-- Statistik-Zeile unten -->
<div class="stats-bar">
	<span title="Gesamtanzahl">G:{{ bps.length }}</span>
	<span class="stat-map" title="Im Kartenausschnitt">K:{{ getMapCount() }}</span>
	<span class="stat-filtered" title="Gefiltert">F:{{ filteredCount }}</span>
	<span class="stat-selected" title="Ausgewählt">A:{{ selectionService.count() }}</span>
	<span class="stat-info" (click)="showStatsHelp()" title="Hilfe"><bi name="info-circle"></bi></span>
</div>

<!-- Statistik-Hilfe Modal -->
<ng-template #statsHelpModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Statistik-Legende</h5>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<table class="table table-sm">
			<tbody>
				<tr>
					<td class="text-muted"><strong>G:</strong></td>
					<td>Gesamtanzahl aller Punkte in der Datenbank</td>
				</tr>
				<tr>
					<td style="color: #98d8a0"><strong>K:</strong></td>
					<td>Anzahl Punkte im aktuellen Kartenausschnitt</td>
				</tr>
				<tr>
					<td style="color: #ffc107"><strong>F:</strong></td>
					<td>Anzahl Punkte, die dem aktiven Filter entsprechen</td>
				</tr>
				<tr>
					<td style="color: #6dd5ed"><strong>A:</strong></td>
					<td>Anzahl ausgewählter Punkte</td>
				</tr>
			</tbody>
		</table>
	</div>
</ng-template>

<!-- Einstellungen Modal -->
<ng-template #settingsModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Listeneinstellungen</h5>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<div class="form-check mb-3">
			<input class="form-check-input" type="checkbox" id="onlyWithProtocol"
				[(ngModel)]="onlyWithProtocol" (ngModelChange)="onSettingsChange()">
			<label class="form-check-label" for="onlyWithProtocol">
				Nur Punkte mit Protokoll anzeigen
			</label>
		</div>
		<hr>
		<div class="mb-3">
			<label class="form-label">Nach oben sortieren</label>
			<select class="form-select form-select-sm" [(ngModel)]="sortToTop" (ngModelChange)="onSettingsChange()">
				<option value="none">– Keine –</option>
				<option value="selected">Ausgewählte Punkte</option>
				<option value="assigned">Dem Projekt zugeordnete Punkte</option>
				<option value="filtered">Gefilterte Punkte</option>
			</select>
		</div>
		<hr>
		<div class="mb-3">
			<label class="form-label">Sortierung</label>
			<select class="form-select form-select-sm" [(ngModel)]="sortOrder" (ngModelChange)="onSettingsChange()">
				<option value="type">Nach Typ</option>
				<option value="nummer">Nach Nummer</option>
				<option value="kartierer">Nach Bearbeiter</option>
				<option value="datum">Nach Datum</option>
			</select>
		</div>
		<hr>
		<!-- Symbol-Legende (ausklappbar) -->
		<details class="mb-2">
			<summary class="form-label legend-toggle">Symbol-Legende</summary>
			<div class="symbol-legend">
				<div class="legend-item"><img src="assets/img/points/1_Weisergrube_ohne_Bodenanalyse.svg" class="legend-icon"><span class="legend-nr">(1)</span> Weisergrube ohne Bodenanalyse</div>
				<div class="legend-item"><img src="assets/img/points/2_Weisergrube_mit_Bodenanalyse.svg" class="legend-icon"><span class="legend-nr">(2)</span> Weisergrube mit Bodenanalyse</div>
				<div class="legend-item"><img src="assets/img/points/3_Bodengrube_ohne_Bodenanalyse.svg" class="legend-icon"><span class="legend-nr">(3)</span> Bodengrube ohne Bodenanalyse</div>
				<div class="legend-item"><img src="assets/img/points/4_Bodengrube_mit_Bodenanalyse.svg" class="legend-icon"><span class="legend-nr">(4)</span> Bodengrube mit Bodenanalyse</div>
				<div class="legend-item"><img src="assets/img/points/5_Humusprobe.svg" class="legend-icon"><span class="legend-nr">(5)</span> Humusprobe</div>
				<div class="legend-item"><img src="assets/img/points/6_Tiefbohrung.svg" class="legend-icon"><span class="legend-nr">(6)</span> Tiefbohrung</div>
				<div class="legend-item"><img src="assets/img/points/7_Moorpunkt.svg" class="legend-icon"><span class="legend-nr">(7)</span> Moorpunkt</div>
				<div class="legend-item"><img src="assets/img/points/8_GW_hoeher_1.svg" class="legend-icon"><span class="legend-nr">(8)</span> feuchter 1 Stufe (GW)</div>
				<div class="legend-item"><img src="assets/img/points/9_GW_hoeher_2.svg" class="legend-icon"><span class="legend-nr">(9)</span> feuchter 2 Stufen (GW)</div>
				<div class="legend-item"><img src="assets/img/points/10_GW_tiefer_1.svg" class="legend-icon"><span class="legend-nr">(10)</span> trockener 1 Stufe (GW)</div>
				<div class="legend-item"><img src="assets/img/points/11_GW_tiefer_2.svg" class="legend-icon"><span class="legend-nr">(11)</span> trockener 2 Stufen (GW)</div>
				<div class="legend-item"><img src="assets/img/points/12_SW_geringer.svg" class="legend-icon"><span class="legend-nr">(12)</span> SW geringer</div>
				<div class="legend-item"><img src="assets/img/points/13_SW_stärker.svg" class="legend-icon"><span class="legend-nr">(13)</span> SW stärker</div>
				<div class="legend-item"><img src="assets/img/points/15_Kleingewaesser.svg" class="legend-icon"><span class="legend-nr">(15)</span> Kleingewässer</div>
				<div class="legend-item legend-invisible"><span class="legend-icon"></span><span class="legend-nr">(16)</span> Einsprengung andere Bodenform <span class="legend-hint">(unsichtbar)</span></div>
				<div class="legend-item"><img src="assets/img/points/17_Nährkraft_höher_1.svg" class="legend-icon"><span class="legend-nr">(17)</span> Nährkraft höher 1</div>
				<div class="legend-item"><img src="assets/img/points/18_Nährkraft_höher_2.svg" class="legend-icon"><span class="legend-nr">(18)</span> Nährkraft höher 2</div>
				<div class="legend-item"><img src="assets/img/points/19_Nährkraft_geringer_1.svg" class="legend-icon"><span class="legend-nr">(19)</span> Nährkraft geringer 1</div>
				<div class="legend-item"><img src="assets/img/points/20_Nährkraft_geringer_2.svg" class="legend-icon"><span class="legend-nr">(20)</span> Nährkraft geringer 2</div>
				<div class="legend-item"><img src="assets/img/points/21_kleinfl_karbonatisch.svg" class="legend-icon"><span class="legend-nr">(21)</span> kleinfl. karbonatisch</div>
				<div class="legend-item"><img src="assets/img/points/23_kleinfl_organisch.svg" class="legend-icon"><span class="legend-nr">(23)</span> kleinfl. organisch</div>
				<div class="legend-item"><img src="assets/img/points/24_kleinfl_mineralisch.svg" class="legend-icon"><span class="legend-nr">(24)</span> kleinfl. mineralisch</div>
				<div class="legend-item"><img src="assets/img/points/31_nMM.svg" class="legend-icon"><span class="legend-nr">(31)</span> nMM</div>
				<div class="legend-item"><img src="assets/img/points/32_fMM.svg" class="legend-icon"><span class="legend-nr">(32)</span> fMM</div>
				<div class="legend-item"><img src="assets/img/points/33_iMM.svg" class="legend-icon"><span class="legend-nr">(33)</span> iMM</div>
				<div class="legend-item"><img src="assets/img/points/34_mMM.svg" class="legend-icon"><span class="legend-nr">(34)</span> mMM</div>
				<div class="legend-item"><img src="assets/img/points/35_tMM.svg" class="legend-icon"><span class="legend-nr">(35)</span> tMM</div>
				<div class="legend-item"><img src="assets/img/points/36_nMo.svg" class="legend-icon"><span class="legend-nr">(36)</span> nMo</div>
				<div class="legend-item"><img src="assets/img/points/37_fMo.svg" class="legend-icon"><span class="legend-nr">(37)</span> fMo</div>
				<div class="legend-item"><img src="assets/img/points/38_iMo.svg" class="legend-icon"><span class="legend-nr">(38)</span> iMo</div>
				<div class="legend-item"><img src="assets/img/points/39_mMo.svg" class="legend-icon"><span class="legend-nr">(39)</span> mMo</div>
				<div class="legend-item"><img src="assets/img/points/42_fRM.svg" class="legend-icon"><span class="legend-nr">(42)</span> fRM</div>
				<div class="legend-item"><img src="assets/img/points/43_iRM.svg" class="legend-icon"><span class="legend-nr">(43)</span> iRM</div>
				<div class="legend-item"><img src="assets/img/points/44_mRM.svg" class="legend-icon"><span class="legend-nr">(44)</span> mRM</div>
				<div class="legend-item"><img src="assets/img/points/47_fRo.svg" class="legend-icon"><span class="legend-nr">(47)</span> fRo</div>
				<div class="legend-item"><img src="assets/img/points/48_iRo.svg" class="legend-icon"><span class="legend-nr">(48)</span> iRo</div>
				<div class="legend-item"><img src="assets/img/points/49_mRo.svg" class="legend-icon"><span class="legend-nr">(49)</span> mRo</div>
				<div class="legend-item"><img src="assets/img/points/61_iHRM.svg" class="legend-icon"><span class="legend-nr">(61)</span> iHRM</div>
				<div class="legend-item"><img src="assets/img/points/64_iHRo.svg" class="legend-icon"><span class="legend-nr">(64)</span> iHRo</div>
				<div class="legend-item"><img src="assets/img/points/65_mHRo.svg" class="legend-icon"><span class="legend-nr">(65)</span> mHRo</div>
				<div class="legend-item legend-invisible"><span class="legend-icon"></span><span class="legend-nr">(70)</span> kleinfl. abweichende Humusform <span class="legend-hint">(unsichtbar)</span></div>
				<div class="legend-item"><img src="assets/img/points/83_stark_verhagerungsgefährdet.svg" class="legend-icon"><span class="legend-nr">(83)</span> stark verhagerungsgefährdet</div>
				<div class="legend-item"><img src="assets/img/points/84_mäßig_verhagerungsgefährdet.svg" class="legend-icon"><span class="legend-nr">(84)</span> mäßig verhagerungsgefährdet</div>
				<div class="legend-item"><img src="assets/img/points/85_schwach_verhagerungsgefährdet.svg" class="legend-icon"><span class="legend-nr">(85)</span> schwach verhagerungsgefährdet</div>
				<div class="legend-item"><img src="assets/img/points/90_GWundNährkraft_höher_1.svg" class="legend-icon"><span class="legend-nr">(90)</span> feuchter 1 Stufe (GW) und Nährkraft höher 1</div>
				<div class="legend-item"><img src="assets/img/points/91_GW_höher_1_Nährkraft_höher_2.svg" class="legend-icon"><span class="legend-nr">(91)</span> feuchter 1 Stufe (GW), Nährkraft höher 2</div>
				<div class="legend-item"><img src="assets/img/points/93_GW_tiefer_1_Nährkraft_höher_1.svg" class="legend-icon"><span class="legend-nr">(93)</span> trockener 1 Stufe (GW), Nährkraft höher 1</div>
				<div class="legend-item"><img src="assets/img/points/94_GW_tiefer_2_Nährkraft_tiefer_1.svg" class="legend-icon"><span class="legend-nr">(94)</span> trockener 2 Stufen (GW), Nährkraft tiefer 1</div>
				<div class="legend-item"><img src="assets/img/points/95_GW_tiefer_1_Nährkraft_tiefer_1.svg" class="legend-icon"><span class="legend-nr">(95)</span> trockener 1 Stufe (GW), Nährkraft tiefer 1</div>
				<div class="legend-item"><img src="assets/img/points/96_GW_tiefer_1_Nährkraft_tiefer_2.svg" class="legend-icon"><span class="legend-nr">(96)</span> trockener 1 Stufe (GW), Nährkraft tiefer 2</div>
				<div class="legend-item"><img src="assets/img/points/97_GW_höher_1_Nährkraft_tiefer_1.svg" class="legend-icon"><span class="legend-nr">(97)</span> feuchter 1 Stufe (GW), Nährkraft tiefer 1</div>
				<div class="legend-item"><img src="assets/img/points/98_GW_höher_2_Nährkraft_tiefer_1.svg" class="legend-icon"><span class="legend-nr">(98)</span> feuchter 2 Stufen (GW), Nährkraft tiefer 1</div>
				<div class="legend-item"><img src="assets/img/points/99_GW_tiefer_2_Nährkraft_höher_1.svg" class="legend-icon"><span class="legend-nr">(99)</span> trockener 2 Stufen (GW), Nährkraft höher 1</div>
				<div class="legend-item"><img src="assets/img/points/100_GW_höher_2_Nährkraft_tiefer_2.svg" class="legend-icon"><span class="legend-nr">(100)</span> feuchter 2 Stufen (GW), Nährkraft tiefer 2</div>
				<div class="legend-item"><img src="assets/img/points/150_Sonderstandort.svg" class="legend-icon"><span class="legend-nr">(150)</span> Sonderstandort</div>
				<div class="legend-item"><img src="assets/img/points/9990_Infopunkt.svg" class="legend-icon"><span class="legend-nr">(9990)</span> Infopunkt</div>
				<div class="legend-item"><img src="assets/img/points/9991_Halbtiefbohrung_mit_Protokoll.svg" class="legend-icon"><span class="legend-nr">(9991)</span> Halbtiefbohrung mit Protokoll</div>
				<div class="legend-item"><img src="assets/img/points/9998_Halbtiefbohrung.svg" class="legend-icon"><span class="legend-nr">(9998)</span> Halbtiefbohrung</div>
				<div class="legend-item"><img src="assets/img/points/9999_Grenzaufschluss.svg" class="legend-icon"><span class="legend-nr">(9999)</span> Grenzaufschluss</div>
			</div>
		</details>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary btn-sm" (click)="modal.close()">Schließen</button>
	</div>
</ng-template>
